import styled, { css } from 'styled-components';
import { calculateColor } from '../../helpers/common';
import { mobile_xl } from '../../global/mediaQueryMixin';

interface ProgressProps {
  size?: number;
  ProgressPercentage?: number;
  status?: number;
}

const ProgressContainer = styled.div<ProgressProps>`
  width: ${({ size }) => size || 12}px;
  height: ${({ size }) => size || 12}px;
  border: 1px solid ${({ status }) => calculateColor(status || 0)};
  border-radius: var(--border-radius-full);
  padding: var(--space-2);
  ${mobile_xl(css`
    width: 14px;
    height: 14px;
  `)}
`;

const ProgressFill = styled.div<ProgressProps>`
  width: ${({ size }) => size || 12}px;
  height: ${({ size }) => size || 12}px;
  border-radius: var(--border-radius-full);
  background: conic-gradient(
    ${({ status }) => calculateColor(status || 0)} ${({ ProgressPercentage }) => ProgressPercentage}%,
    0,
    transparent 100%
  );
  ${mobile_xl(css`
    width: 14px;
    height: 14px;
  `)}
`;

export { ProgressFill, ProgressContainer };
